/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState, useEffect } from "react";
import { useParams, NavLink } from "react-router-dom";
import AllReports from "./AllReports";

const PreAuthList = () => {
  const [selectedTab, setSelectedTab] = useState("preauth");
  const { tab } = useParams();
  localStorage.setItem("patients-offset", 1);

  useEffect(() => {
    return () => localStorage.removeItem("patients-offset");
  }, []);

  useEffect(() => {
    if (typeof tab === "undefined") setSelectedTab("preauth");
    else setSelectedTab(tab);
  }, [tab]);

  const classNameTab = (pos) => (pos === selectedTab ? "tabActive" : "");

  return (
    <div id="index" className="containerFlex maxHd">
      <div className="contentArea">
        <nav className="tabs" id="report-navigation">
          <NavLink
            to="/reports3/preauth"
            id="tab-preauth-30"
            className={classNameTab("preauth")}
            onClick={() => {
              localStorage.setItem("patients-offset", 1);
              setSelectedTab("preauth");
            }}
          >
            <span className="tab-text">Preauth 30</span>
          </NavLink>
          <NavLink
            to="/reports3/preauth/90"
            id="tab-preauth-90"
            className={classNameTab("90")}
            onClick={() => {
              localStorage.setItem("patients-offset", 1);
              setSelectedTab("90");
            }}
          >
            <span className="tab-text">Preauth 90</span>
          </NavLink>
        </nav>

        <div className="tabContent">
          <AllReports activeTab={selectedTab} />
        </div>
      </div>
    </div>
  );
};

export default PreAuthList;
